var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.review)?_c('app-reviewform',{attrs:{"parentObject":{
        review: this.review,
        list: this.list,
        roleName: this.roleName
    }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }